// import 'lightbox2';

import Glide from '@glidejs/glide';


var glide = new Glide('.glide', {
    autoplay: 4000,
    hoverpause: false
  });

  glide.mount();